import React from "react";

const BrandIcon = ({ width = 85, height = 85, fill = "#787882", className }) => {
    return (
        <svg
            class="svg-icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
        >
            <path fill={fill} d="M160.3 456.9c-11.8 0-22.7-6.5-28.3-17-5.6-10.5-4.9-23.2 1.8-33l180.3-264.5c5.9-8.7 15.8-13.9 26.4-14l342-0.9h0.1c10.5 0 20.4 5.2 26.3 13.8l181.7 263.5c6.7 9.8 7.5 22.5 2 33s-16.4 17.1-28.3 17.2l-704 1.9c0.1 0 0.1 0 0 0z m197.3-264.5L221 392.7l582.5-1.6-137.7-199.6-308.2 0.9z" />
            <path fill={fill} d="M513 896c-9.7 0-18.9-4.4-25-12L136 444c-7.7-9.6-9.2-22.8-3.9-33.9 5.3-11.1 16.5-18.1 28.8-18.1h704c12.3 0 23.5 7.1 28.8 18.1 5.3 11.1 3.8 24.2-3.9 33.9L538 884c-6.1 7.6-15.3 12-25 12zM227.6 456L513 812.8 798.4 456H227.6z" />
            <path fill={fill} d="M513 885c-13.4 0-25.9-8.5-30.4-22l-142-429c-2.4-7.1-2.1-14.8 0.6-21.8l103-262c6.5-16.4 25-24.5 41.5-18.1 16.4 6.5 24.5 25 18.1 41.5L405 424.9l138.4 418c5.6 16.8-3.5 34.9-20.3 40.4-3.4 1.2-6.8 1.7-10.1 1.7z" />
            <path fill={fill} d="M513.3 885.1c-3.3 0-6.7-0.5-10-1.6-16.8-5.5-25.9-23.6-20.4-40.4l138-418.1-99-251.1c-6.5-16.4 1.6-35 18-41.5s35 1.6 41.5 18l103.2 261.9c2.7 7 3 14.7 0.6 21.8l-141.5 429c-4.5 13.4-17 22-30.4 22z" />
        </svg>
    );
};

export default BrandIcon;
